import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './LanguageToggle.style';

const LANGS: Array<'de' | 'en'> = ['de', 'en'];

const LanguageToggle: React.FC = () => {
  const { i18n } = useTranslation();
  const current = (i18n.language || 'de').slice(0, 2).toLowerCase();

  return (
    <S.Group role="group" aria-label="Sprache wählen" data-testid="language-toggle">
      {LANGS.map((lng) => (
        <S.Segment
          key={lng}
          $active={current === lng}
          onClick={() => i18n.changeLanguage(lng)}
          aria-pressed={current === lng}
          data-testid={`language-option-${lng}`}
        >
          {lng.toUpperCase()}
        </S.Segment>
      ))}
    </S.Group>
  );
};

export default LanguageToggle;
